import React, { useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';

const box = 'w-full min-w-0 rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-200 focus:border-amber-500/60 focus:outline-none';

// Add a norm to watch: from the supported catalog or any Ley N° resolved officially in LeyChile
export const AddWatchForm = ({ catalog, matters, onDone }) => {
  const { api } = useAuth();
  const [f, setF] = useState({ norm_id: '', ley_numero: '', matter_id: '', articles: '', materia: '', reason: '' });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.post('/watched-laws', { ...f, norm_id: f.norm_id || null, ley_numero: f.norm_id ? null : f.ley_numero, matter_id: f.matter_id || null,
        articles: f.articles.split(',').map((a) => a.trim()).filter(Boolean) });
      r.data.first_check.ok ? toast.success('Norma vigilada: primera consulta a BCN exitosa') : toast.warning(`Norma agregada, pero la consulta a BCN falló: ${r.data.first_check.error}`);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || 'No se pudo agregar'); } finally { setBusy(false); }
  };
  return (
    <div data-testid="watch-add-form" className="grid grid-cols-1 gap-3 rounded-2xl border border-amber-500/30 bg-amber-500/5 p-5 md:grid-cols-2 [&>*]:min-w-0">
      <select data-testid="watch-add-norm" value={f.norm_id} onChange={set('norm_id')} className={box}>
        <option value="">Otra ley (indica su número) →</option>
        {catalog.map((c) => <option key={c.norm_id} value={c.norm_id}>{c.name}</option>)}
      </select>
      <input data-testid="watch-add-ley" disabled={!!f.norm_id} value={f.ley_numero} onChange={set('ley_numero')} placeholder="N° de ley, ej. 21.719 (se busca en LeyChile)" className={`${box} disabled:opacity-40`} />
      <select data-testid="watch-add-matter" value={f.matter_id} onChange={set('matter_id')} className={box}>
        <option value="">Sin causa asociada</option>
        {matters.map((m) => <option key={m.id} value={m.id}>{m.title}</option>)}
      </select>
      <input data-testid="watch-add-articles" value={f.articles} onChange={set('articles')} placeholder="Artículos relevantes, separados por coma (ej. 7, 18-B)" className={box} />
      <input data-testid="watch-add-materia" value={f.materia} onChange={set('materia')} placeholder="Materia (ej. arrendamiento urbano)" className={box} />
      <input data-testid="watch-add-reason" value={f.reason} onChange={set('reason')} placeholder="Motivo del seguimiento" className={box} />
      <button data-testid="watch-add-save" disabled={busy || (!f.norm_id && !f.ley_numero.trim())} onClick={save} className="w-fit rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-40">{busy ? 'Consultando LeyChile…' : 'Vigilar'}</button>
    </div>
  );
};
